import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MeetingBookingLink } from '../models/meeting-booking-link.model';

@Injectable({
  providedIn: 'root'
})
export class MeetingBookingLinkApiService {
  private readonly apiUrl = `${environment.apiUrl}api/meeting-books-links`;

  constructor(private http: HttpClient) {}

  filterActiveLinks(businessId: number): Observable<MeetingBookingLink[]> {
    const params = new HttpParams()
      .set('businessId', businessId)
      .set('isActive', true);

    return this.http.get<MeetingBookingLink[]>(`${this.apiUrl}/filter`, { params });
  }
}
